import {
  Add,
  CheckBoxOutlined,
  PeopleOutline,
  SentimentSatisfiedOutlined,
  Translate,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";

import NavBar from "../../components/NavBar/NavBar";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

import JoinImg from "../../images/join.png";
import JoinImg2 from "../../images/join2.png";
import T1 from "../../images/translators/t1.jpg";
import T2 from "../../images/translators/t2.jpg";
import T3 from "../../images/translators/t3.jpg";
import T4 from "../../images/translators/t4.jpg";
import T5 from "../../images/translators/t5.jpg";
import T6 from "../../images/translators/t6.jpg";
import T7 from "../../images/translators/t7.jpg";
import T8 from "../../images/translators/t8.jpg";

import "./Join.css";

const Join = () => {
  const history = useHistory();
  const location = useLocation();
  const [openFaq, setOpenFaq] = useState("");

  const handleOpenFaq = (num) => {
    if (num === openFaq) setOpenFaq("");
    else setOpenFaq(num);
  };

  useEffect(() => {
    if (location.hash.slice(1).trim() !== "") {
      const element = document.getElementById(location.hash.slice(1).trim());

      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const openStyle = {
    height: "250px",
    opacity: 1,
  };

  return (
    <div className="join">
      <NavBar join />
      <div className="join__hero container d-flex align-end justify-between">
        <div className="d-flex flex-column justify-end h-100 py-20">
          <h2 className="font-large py-20">
            Grow with OneConverse Translations
          </h2>
          <p className="font-heavy">
            Join our team of translaors and work on interesting and amazing
            projects.
          </p>
          <button
            className="border-0 outline-0 font-big font-bold rounded p-10 my-20"
            onClick={() => history.push("/auth/signup#translator")}
          >
            JOIN AS A TRANSLATOR
          </button>
        </div>
        <div className="join__hero__right d-flex justify-center">
          <img src={JoinImg} alt="" />
        </div>
      </div>
      <div className="container">
        <div className="join__record d-flex justify-evenly rounded px-40 py-20 my-40">
          <div className="d-flex justify-center align-center">
            <div className="d-flex align-center justify-center rounded-50 mr-20">
              <PeopleOutline className="icon-light-grey" fontSize="large" />
            </div>
            <div className="d-flex flex-column justify-center align-center">
              <span className="font-bigger font-bold lh-sm">10,000+</span>
              <span className="font-sm">Translators</span>
            </div>
          </div>
          <div className="d-flex justify-center align-center">
            <div className="d-flex align-center justify-center rounded-50 mr-20">
              <Translate className="icon-light-grey" fontSize="large" />
            </div>
            <div className="d-flex flex-column justify-center align-center">
              <span className="font-bigger font-bold lh-sm">1000+</span>
              <span className="font-sm">Languages</span>
            </div>
          </div>
          <div className="d-flex justify-center align-center">
            <div className="d-flex align-center justify-center rounded-50 mr-20">
              <SentimentSatisfiedOutlined
                className="icon-light-grey"
                fontSize="large"
              />
            </div>
            <div className="d-flex flex-column justify-center align-center">
              <span className="font-bigger font-bold lh-sm">99.99%</span>
              <span className="font-sm">Client Satisfaction</span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <h2 className="font-subhead text-center py-40">
          See Our Pool of Translators
        </h2>
        <div className="join__translators grid c-4">
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T1} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                Lainey Jackson
              </span>
              <span className="text-capitalise font-sm lh-sm">USA</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T2} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                Daniel Hernandez
              </span>
              <span className="text-capitalise font-sm lh-sm">Spain</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T3} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                Muyiwa Onohinosen
              </span>
              <span className="text-capitalise font-sm lh-sm">Nigeria</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T4} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                Kenneth Edwards
              </span>
              <span className="text-capitalise font-sm lh-sm">UK</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T5} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                لمار المحمودي
              </span>
              <span className="text-capitalise font-sm lh-sm">UAE</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T6} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">Hans Vog</span>
              <span className="text-capitalise font-sm lh-sm">Germany</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T7} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">平 丁</span>
              <span className="text-capitalise font-sm lh-sm">China</span>
            </div>
          </div>
          <div className="join__translators__img d-flex flex-column align-center justify-center m-10">
            <img src={T8} alt="" />
            <div className="d-flex flex-column align-center py-5">
              <span className="text-capitalise font-bold lh-sm">
                Malo Meunier
              </span>
              <span className="text-capitalise font-sm lh-sm">France</span>
            </div>
          </div>
        </div>
      </div>
      <div className="join__why container d-flex align-start justify-around my-40">
        <div>
          <h2 className="font-subhead my-40">Why work with us?</h2>
          <div className="d-flex align-center py-10 font-big">
            <CheckBoxOutlined className="icon-blue mr-20" fontSize="small" />
            <span>Career Growth</span>
          </div>
          <div className="d-flex align-center py-10 font-big">
            <CheckBoxOutlined className="icon-blue mr-20" fontSize="small" />
            <span>Punctual Payments</span>
          </div>
          <div className="d-flex align-center py-10 font-big">
            <CheckBoxOutlined className="icon-blue mr-20" fontSize="small" />
            <span>Interesting Projects</span>
          </div>
          <div className="d-flex align-center py-10 font-big">
            <CheckBoxOutlined className="icon-blue mr-20" fontSize="small" />
            <span>Expert Project Managers</span>
          </div>
          <div className="d-flex align-center py-10 font-big">
            <CheckBoxOutlined className="icon-blue mr-20" fontSize="small" />
            <span>Seamless transaction workflow</span>
          </div>
        </div>
        <div className="join__why__right d-flex justify-center">
          <img src={JoinImg2} alt="" />
        </div>
      </div>
      <div className="join__how d-flex flex-column align-center container my-40">
        <h2 className="font-subhead px-20 py-20 ">How to Apply</h2>
        <div className="d-flex flex-wrap justify-between w-100">
          <div className="d-flex flex-column align-center justify-between p-20 mb-20">
            <span className="text-center">Creat an account</span>
            <span className="my-10 font-big">01</span>
          </div>
          <div className="d-flex flex-column align-center justify-between p-20 mb-20">
            <span className="text-center">Verify Email</span>
            <span className="my-10 font-big">02</span>
          </div>
          <div className="d-flex flex-column align-center justify-between p-20 mb-20">
            <span className="text-center">Build Profile</span>
            <span className="my-10 font-big">03</span>
          </div>
          <div className="d-flex flex-column align-center justify-between p-20 mb-20">
            <span className="text-center">Profile Approval</span>
            <span className="my-10 font-big">04</span>
          </div>
          <div className="d-flex flex-column align-center justify-between p-20 mb-20">
            <span className="text-center">OneConverse Translator</span>
            <span className="my-10 font-big">05</span>
          </div>
        </div>
        <button
          className="border-0 outline-0 py-10 px-20 mb-20 mt-20 font-big rounded"
          onClick={() => history.push("/auth/signup#translator")}
        >
          Apply Now
        </button>
      </div>
      <div id="faq" className="container">
        <div className="join__faq p-40">
          <h2 className="font-subhead text-center">
            Frequently Asked Questions
          </h2>
          <div className="d-flex justify-between px-40 m-40">
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(1)}
              >
                <span className="font-heavy mx-40">
                  When do I need a certification service?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 1 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                Documents that are to be used abroad for legal purposes, are
                best translated and certified before usage in a foreign country.
                Most frequently used examples are export documentation, legal
                documents for expanding businesses in a foreign country, medical
                documentation, patents as well as personal certificates like
                birth, death or divorce certificate. There are various types of
                certification which can be explained in detail by our team, in
                order for us to provide the most suitable certification service
                for your needs.
              </div>
            </div>
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(2)}
              >
                <span className="font-heavy mx-40">
                  When is a translation considered to be 'certified'?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 2 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                The translation will have been produced by a sworn translator
                (outside of the UK), the translation has been completed by an
                accredited language provider (like London Translations) or the
                certification of the translated content has been completed in
                front of a solicitor or legally qualified professional.
              </div>
            </div>
          </div>
          <div className="d-flex justify-between px-40 m-40">
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(3)}
              >
                <span className="font-heavy mx-40">
                  What documents are covered by the certified translation
                  service?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 3 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                <ul>
                  <li>Business and corporate (legal) documents</li>
                  <li>Academic certificates and Diplomas</li>
                  <li>
                    Government documents (such as immigration documents or
                    medical reports)
                  </li>
                  <li>
                    Personal documents such adoption certificate, driver’s
                    license, birth certificate, death certificate and divorce
                    certificate
                  </li>
                  <li>Passports and Identification documents</li>
                </ul>
              </div>
            </div>
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(4)}
              >
                <span className="font-heavy mx-40">
                  How long will it take to complete a certified translation?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 4 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                The duration of the completion of the certified translation will
                depend on the length of your document(s). Once the quote has
                been approved by you, the time-frame for completing your project
                will be confirmed. A professional linguist will be able to
                process between 2,000 and 2,500 words per day. Additional time
                will be added for our standard quality control process.
              </div>
            </div>
          </div>
          <div className="d-flex justify-between px-40 m-40">
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(5)}
              >
                <span className="font-heavy mx-40">
                  Will the certification be completed by London Translations or
                  the linguist completing the translation?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 5 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                We mark in-house certifications with both the London
                Translations stamp and the signature of your assigned project
                manager. As an ISO-accredited organisation, we are authorised to
                provide the verification, ensuring that each translation is of
                high-quality, accurate, and recognised by governments abroad.
                However, we also have the option of the translator’s
                certificate. This stamp of approval will be directly provided by
                the linguist responsible for the translation (rather than London
                Translations’ project manager). Clients may prefer this means of
                certification, and request information regarding the translator
                in order to prove the content’s credibility. All information
                will be provided through the London Translations’ project
                manager.
              </div>
            </div>
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(6)}
              >
                <span className="font-heavy mx-40">
                  Can you clarify the process of translation and certification?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 6 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                Our process has been optimised to provide the best customer
                experience possible. After you have submitted your request for a
                quote (through this page), we will provide a quote to you. Once
                approved, we will start the process of translation. The
                certification will be completed immediately following your
                approval of the translation and we will provide you with the
                required documents and certification within the agreed time
                scale. A dedicated project manager will be available at all time
                for questions or updates.
              </div>
            </div>
          </div>
          <div className="d-flex justify-between px-40 m-40">
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(7)}
              >
                <span className="font-heavy mx-40">
                  Does London Translations collaborate with UK government bodies
                  on the translation of official documents?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 7 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                We provide legal and certified documents to the Home Office, UK
                Courts of Law and UK educational institutions. In addition to
                providing translated documents in English, we work closely
                together with government agencies in Europe for the completion
                and provisioning of translations into European languages.
              </div>
            </div>
            <div className="w-45">
              <div
                className="join__faq__question d-flex align-center justify-between px-10 py-20 pointer"
                onClick={() => handleOpenFaq(8)}
              >
                <span className="font-heavy mx-40">
                  Are your translations certified?
                </span>
                <Add className="icon-blue" />
              </div>
              <div
                style={openFaq === 8 ? openStyle : {}}
                className="join__faq__content p-10 border-top-1"
              >
                We offer the option to add a Certificate of Translation Accuracy
                (see example here) to your order. This certificate attests that
                the translation was carried out by a professional native
                translator to the best of his/her ability. Certified
                translations have an additional cost of €15.00 (or 3% of the
                total price for orders over €500). Please note that this
                certification is not the same as a sworn translation service,
                i.e. a translation done by an officially appointed (sworn)
                translator. If you are interested in sworn translation services,
                please visit this page.
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactUs />
      <div className="container">
        <div className="join__translator my-40 text-center py-20 px-40 w-100">
          <h2 className="font-heading pb-10 pt-20">
            Join our Pool of Translators
          </h2>
          <p className="font-heavy font-normal">
            Join the world best translating company and get exposed to high
            class team members.
            <br />
            From all over the world, translate for top companies and
            individuals.
          </p>
          <button
            className="button my-20"
            onClick={() => history.push("/auth/signup#translator")}
          >
            Apply Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Join;
